export const pt = {
  "Rubrics": "Rubricas",
  "New Rubric": "Nova rubrica",
  "Create scoring rubrics for any topic, subject, or assignment": "Crie rubricas de avaliação para qualquer tema, disciplina ou tarefa",
  "AI Draft": "Rascunho com IA",
  "Start Blank": "Começar em branco",
  "Topic / what to assess": "Tema / o que avaliar",
  "Class (optional)": "Turma (opcional)",
  "Title (optional)": "Título (opcional)",
  "Levels": "Níveis",
  "Generate Rubric": "Gerar rubrica",
  "Create": "Criar",
  "Criteria": "Critérios",
  "Criterion name": "Nome do critério",
  "Descriptor...": "Descritor...",
  "Add Criterion": "Adicionar critério",
  "Add level": "Adicionar nível",
  "Remove level": "Remover nível",
  "Remove": "Remover",
  "Score Student": "Avaliar aluno",
  "Save to Gradebook": "Salvar no diário",
  "Tap cells below to score": "Toque nas células para avaliar",
  "Select student": "Selecionar aluno",
  "Select a rubric or create a new one": "Selecione uma rubrica ou crie uma nova",
  "No rubrics yet. Create your first one!": "Ainda sem rubricas. Crie a primeira!",
  "Rubric created!": "Rubrica criada!",
  "Rubric saved": "Rubrica salva",
  "Rubric deleted": "Rubrica excluída",
  "Rubric duplicated": "Rubrica duplicada",
  "Delete this rubric?": "Excluir esta rubrica?",
  "Duplicate": "Duplicar",
  "No class": "Sem turma",
  "Rubric": "Rubrica",
  "Saved to gradebook": "Salvo no diário",
  "Failed to save score": "Falha ao salvar a nota",
  "Select a class and student": "Selecione uma turma e um aluno",
  "Failed to create rubric. Please try again.": "Falha ao criar. Tente novamente.",
  "Analyzing the topic...": "Analisando o tema...",
  "Defining criteria...": "Definindo critérios...",
  "Writing level descriptors...": "Escrevendo descritores...",
  "Excellent": "Excelente",
  "Good": "Bom",
  "Fair": "Regular",
  "Needs Improvement": "Precisa melhorar",
  "New Level": "Novo nível",
  "Total points possible": "Total de pontos possíveis",
  "Loading...": "Carregando...",
  "Failed to duplicate": "Falha ao duplicar",
  "Send to Google Classroom": "Enviar para o Google Classroom",
  "Opening Google Classroom...": "Abrindo o Google Classroom...",
  "Failed to share to Classroom": "Falha ao compartilhar no Classroom",
  "Analyzing standards...": "Analisando padrões...",
  "Writing content...": "Redigindo conteúdo...",
  "Formatting sections...": "Formatando seções...",
  "Finalizing...": "Finalizando...",
  "All Plans": "Todos os planos",
  "Color": "Cor",
  "Current": "Atual",
  "Delete": "Excluir",
  "Delete this folder? Plans will be moved to \"Unfiled\"": "Excluir esta pasta? Os planos serão movidos para \"Sem pasta\"",
  "Edit": "Editar",
  "Edit Folder": "Editar pasta",
  "Error creating folder": "Erro ao criar a pasta",
  "Error deleting folder": "Erro ao excluir a pasta",
  "Error moving plan": "Erro ao mover o plano",
  "Error updating folder": "Erro ao atualizar a pasta",
  "Ex: Math 5th Grade": "Ex: Matemática 5º Ano",
  "Folder created": "Pasta criada",
  "Folder deleted": "Pasta excluída",
  "Folder name": "Nome da pasta",
  "Folder updated": "Pasta atualizada",
  "Folders": "Pastas",
  "Move to folder": "Mover para pasta",
  "New Folder": "Nova pasta",
  "No objective defined": "Nenhum objetivo definido",
  "No unfiled plans": "Nenhum plano sem pasta",
  "Plan moved": "Plano movido",
  "This folder is empty": "Esta pasta está vazia",
  "Unfiled": "Sem pasta",
  "You don't have any lesson plans": "Você não tem planos de aula",
  "Your lesson plans": "Seus planos de aula",
  "Take Attendance": "Fazer chamada",
  "You have": "Você tem",
  "class(es) without attendance today": "turma(s) sem chamada hoje",
  "Student Intervention Needed": "Intervenção necessária com alunos",
  "student(s) showing significant struggles - consider reaching out": "aluno(s) com dificuldades significativas - considere entrar em contato",
  "Overdue Grading": "Correções atrasadas",
  "assignment(s) past due date need grading": "tarefa(s) vencida(s) para corrigir",
  "Plan Next Week": "Planejar a próxima semana",
  "class(es) don't have lessons planned for next week": "turma(s) sem aulas planejadas para a próxima semana",
  "10th Grade": "10º Ano",
  "11th Grade": "11º Ano",
  "12th Grade": "12º Ano",
  "1st Grade": "1º Ano",
  "2nd Grade": "2º Ano",
  "3rd Grade": "3º Ano",
  "4th Grade": "4º Ano",
  "5th Grade": "5º Ano",
  "6th Grade": "6º Ano",
  "7th Grade": "7º Ano",
  "8th Grade": "8º Ano",
  "9th Grade": "9º Ano",
  "AI Assignment generated": "Tarefa de IA gerada",
  "AI Assignments": "Tarefas de IA",
  "AI Assistant": "Assistente de IA",
  "AI Generated": "Gerado por IA",
  "AI Grading": "Correção com IA",
  "AI Recommendations": "Recomendações de IA",
  "AI Suggestions": "Sugestões de IA",
  "AI Teaching Assistant": "Assistente pedagógico de IA",
  "Access Link": "Link de acesso",
  "Access resources to help plan your lessons": "Acesse recursos para ajudar a planejar suas aulas",
  "Activity Ideas": "Ideias de atividades",
  "Adapt": "Adaptar",
  "Adapt with AI": "Adaptar com IA",
  "Adaptive Learning": "Aprendizagem adaptativa",
  "Add": "Adicionar",
  "Add New Category": "Adicionar nova categoria",
  "Add Question": "Adicionar pergunta",
  "Add option": "Adicionar opção",
  "Add pair": "Adicionar par",
  "Add to Calendar": "Adicionar ao calendário",
  "Additional Instructions (optional)": "Instruções adicionais (opcional)",
  "Additional Notes": "Notas adicionais",
  "Additional instructions": "Instruções adicionais",
  "Additional notes...": "Notas adicionais...",
  "All caught up!": "Tudo em dia!",
  "All semesters": "Todos os semestres",
  "All students on track!": "Todos os alunos no caminho certo!",
  "All suggestions applied": "Todas as sugestões aplicadas",
  "Analysis took too long. Please try again.": "A análise demorou demais. Tente novamente.",
  "Analyzing PDF with AI... This may take up to a minute.": "Analisando PDF com IA... Isso pode levar até um minuto.",
  "Analyzing...": "Analisando...",
  "Answer Key": "Gabarito",
  "Answer:": "Resposta:",
  "Apply All": "Aplicar tudo",
  "Apply as-is": "Aplicar como está",
  "Apply to notes": "Aplicar às notas",
  "Approve & Publish": "Aprovar e publicar",
  "Art": "Artes",
  "Ask me about planning, standards, teaching strategies...": "Pergunte-me sobre planejamento, padrões, estratégias de ensino...",
  "Assessment": "Avaliação",
  "Assignment List": "Lista de tarefas",
  "Assignment created": "Tarefa criada",
  "Assignment created!": "Tarefa criada!",
  "Assignment created. Student link copied to clipboard.": "Tarefa criada. Link do aluno copiado para a área de transferência.",
  "Assignment deleted": "Tarefa excluída",
  "Assignment name": "Nome da tarefa",
  "Assignment updated": "Tarefa atualizada",
  "Assignments & Gradebook": "Tarefas e diário de notas",
  "Assignments to Grade": "Tarefas para corrigir",
  "At Risk": "Em risco",
  "Attendance": "Frequência",
  "Attendance Rpt": "Relatório de frequência",
  "Attendance saved": "Frequência salva",
  "Automate your entire Sunday night prep with a single prompt": "Automatize toda a sua preparação de domingo à noite com um único comando",
  "Back": "Voltar",
  "Based on grades & attendance": "Com base em notas e frequência",
  "Bilingual": "Bilíngue",
  "Both (CC + PR)": "Ambos (CC + PR)",
  "Briefly describe what makes this lesson structure successful...": "Descreva brevemente o que torna esta estrutura de aula bem-sucedida...",
  "Build Questions": "Criar perguntas",
  "CC + PR": "CC + PR",
  "Calendar": "Calendário",
  "Calendar Events": "Eventos do calendário",
  "Cancel": "Cancelar",
  "Cannot delete category with assignments": "Não é possível excluir categoria com tarefas",
  "Categories": "Categorias",
  "Category": "Categoria",
  "Category created": "Categoria criada",
  "Category deleted": "Categoria excluída",
  "Category updated": "Categoria atualizada",
  "Chat": "Chat",
  "Chat with AI Assistant": "Converse com o assistente de IA",
  "Choose File": "Escolher arquivo",
  "Class": "Turma",
  "Class created": "Turma criada",
  "Class deleted": "Turma excluída",
  "Class updated": "Turma atualizada",
  "Classes Today": "Aulas hoje",
  "Close": "Fechar",
  "Closure": "Encerramento",
  "Column A": "Coluna A",
  "Column B": "Coluna B",
  "Complete required fields": "Preencha os campos obrigatórios",
  "Connecting to server... Retrying": "Conectando ao servidor... Tentando novamente",
  "Content generated! Use the Save button to save it.": "Conteúdo gerado! Use o botão Salvar para salvá-lo.",
  "Convert to Online Test": "Converter em teste online",
  "Copied!": "Copiado!",
  "Copy": "Copiar",
  "Copy Link": "Copiar link",
  "Copy link": "Copiar link",
  "Copy student link": "Copiar link do aluno",
  "Core": "Núcleo",
  "Correct answer": "Resposta correta",
  "Create assessments with answers": "Crie avaliações com gabarito",
  "Create with AI": "Criar com IA",
  "Created with TeacherHubPro - AI Assistant for Teachers": "Criado com TeacherHubPro - Assistente de IA para professores",
  "Creative classroom activities": "Atividades criativas para a sala de aula",
  "Current Categories": "Categorias atuais",
  "Customized template applied!": "Modelo personalizado aplicado!",
  "Dark": "Escuro",
  "Dark mode": "Modo escuro",
  "Date Range (2 Weeks)": "Período (2 semanas)",
  "Date of Test/Quiz": "Data do teste/quiz",
  "Day theme...": "Tema do dia...",
  "Delete this assignment?": "Excluir esta tarefa?",
  "Delete this prep batch?": "Excluir esta preparação?",
  "Delete this template?": "Excluir este modelo?",
  "Deleted": "Excluído",
  "Describe the learning goal...": "Descreva o objetivo de aprendizagem...",
  "Describe what you need to prep and the agent will generate everything automatically": "Descreva o que você precisa preparar e o agente gerará tudo automaticamente",
  "Describe your lesson and AI will generate a standards-based plan.": "Descreva sua aula e a IA gerará um plano baseado nos padrões.",
  "Description": "Descrição",
  "Description / Instructions": "Descrição / Instruções",
  "Differentiation strategies": "Estratégias de diferenciação",
  "Difficulty": "Dificuldade",
  "Done": "Concluído",
  "Due Date (optional)": "Data de entrega (opcional)",
  "Due:": "Entrega:",
  "Duration (minutes)": "Duração (minutos)",
  "E.g., Decimal multiplication": "Ex.: Multiplicação de decimais",
  "E.g., Equivalent fractions": "Ex.: Frações equivalentes",
  "E.g., Focus on word problems...": "Ex.: Foco em problemas escritos...",
  "E.g., Fractions Plan - 4th Grade": "Ex.: Plano de Frações - 4º Ano",
  "E.g., Fractions with different denominators": "Ex.: Frações com denominadores diferentes",
  "E.g., Fractions, American Revolution...": "Ex.: Frações, Revolução Americana...",
  "E.g., math, fractions, hands-on": "Ex.: matemática, frações, prático",
  "ELA": "Língua Portuguesa",
  "Easy": "Fácil",
  "Edit Assignment": "Editar tarefa",
  "Edit Class": "Editar turma",
  "Edit Parent Email": "Editar e-mail aos pais",
  "Edit class": "Editar turma",
  "Educational Games": "Jogos educativos",
  "End": "Fim",
  "English": "Inglês",
  "English/Reading": "Inglês/Leitura",
  "Enjoy your day off": "Aproveite seu dia de folga",
  "Enrichment": "Enriquecimento",
  "Enter a topic": "Digite um tópico",
  "Enter question...": "Digite a pergunta...",
  "Enter your prep request": "Digite seu pedido de preparação",
  "Error applying template": "Erro ao aplicar o modelo",
  "Error creating class": "Erro ao criar a turma",
  "Error customizing": "Erro ao personalizar",
  "Error deleting": "Erro ao excluir",
  "Error exporting calendar": "Erro ao exportar o calendário",
  "Error generating link": "Erro ao gerar o link",
  "Error generating plan": "Erro ao gerar o plano",
  "Error generating suggestions": "Erro ao gerar sugestões",
  "Error generating weekly plan": "Erro ao gerar o plano semanal",
  "Error loading AI assignments": "Erro ao carregar tarefas de IA",
  "Error loading template": "Erro ao carregar o modelo",
  "Error loading templates": "Erro ao carregar os modelos",
  "Error saving template": "Erro ao salvar o modelo",
  "Error sending email": "Erro ao enviar o e-mail",
  "Essay": "Dissertação",
  "Essay answers are graded manually": "Dissertações são corrigidas manualmente",
  "Everything published successfully!": "Tudo publicado com sucesso!",
  "Ex: Chapter 1 - Vocabulary": "Ex: Capítulo 1 - Vocabulário",
  "Ex: English": "Ex: Inglês",
  "Ex: Greetings and Introductions": "Ex: Saudações e apresentações",
  "Ex: Prep next week for Unit 3 History (Civil War), matching state curriculum standards": "Ex: Preparar a próxima semana para a Unidade 3 de História (Guerra Civil), conforme os padrões curriculares",
  "Ex: Unit 1": "Ex: Unidade 1",
  "Expiration (days)": "Expiração (dias)",
  "Expires:": "Expira:",
  "Failed to delete": "Falha ao excluir",
  "Failed to generate assignment": "Falha ao gerar a tarefa",
  "Failed to generate content. Please try again.": "Falha ao gerar o conteúdo. Tente novamente.",
  "Failed to load data": "Falha ao carregar os dados",
  "Failed to parse PDF": "Falha ao analisar o PDF",
  "Failed to publish": "Falha ao publicar",
  "Failed to save": "Falha ao salvar",
  "Failed to start agent": "Falha ao iniciar o agente",
  "Failed to upload file": "Falha ao enviar o arquivo",
  "False": "Falso",
  "File uploaded": "Arquivo enviado",
  "Fill Blank": "Preencher lacunas",
  "First and last name required": "Nome e sobrenome obrigatórios",
  "Friday Quiz": "Quiz de sexta-feira",
  "From": "De",
  "Full weekly plan generated! Review each day.": "Plano semanal completo gerado! Revise cada dia.",
  "Generate": "Gerar",
  "Generate Assignment": "Gerar tarefa",
  "Generate Assignment with AI": "Gerar tarefa com IA",
  "Generate Content": "Gerar conteúdo",
  "Generate Full Week": "Gerar semana completa",
  "Generate Plan": "Gerar plano",
  "Generate Plan with AI": "Gerar plano com IA",
  "Generate a structured weekly lesson plan with objectives, daily activities, and materials.": "Gere um plano de aula semanal estruturado com objetivos, atividades diárias e materiais.",
  "Generate a weekly plan with AI and save it as a template": "Gere um plano semanal com IA e salve-o como modelo",
  "Generate complete lesson plans": "Gere planos de aula completos",
  "Generate content and use the \"Save Content\" button to save it here": "Gere conteúdo e use o botão \"Salvar conteúdo\" para salvá-lo aqui",
  "Generate materials based on National Standards, instantly.": "Gere materiais baseados nos Padrões Nacionais, instantaneamente.",
  "Generate practice worksheets": "Gere folhas de exercícios",
  "Generate with AI": "Gerar com IA",
  "Generated Content": "Conteúdo gerado",
  "Generated Questions": "Perguntas geradas",
  "Generated content will appear here": "O conteúdo gerado aparecerá aqui",
  "Generated with AI Assistant": "Gerado com o assistente de IA",
  "Generating content...": "Gerando conteúdo...",
  "Generating link...": "Gerando link...",
  "Generating week...": "Gerando semana...",
  "Generating...": "Gerando...",
  "Generation failed.": "Falha na geração.",
  "Generation failed. Please try again.": "Falha na geração. Tente novamente.",
  "Generation timed out": "Tempo de geração esgotado",
  "Generation took too long. Please try again.": "A geração demorou demais. Tente novamente.",
  "Geography": "Geografia",
  "Get detailed topic summaries": "Obtenha resumos detalhados de tópicos",
  "Go to SM Aprendizaje": "Ir para SM Aprendizaje",
  "Grade": "Ano",
  "Grade Level": "Ano escolar",
  "Grade Level *": "Ano escolar *",
  "Grade Report": "Boletim de notas",
  "Grade Scale": "Escala de notas",
  "Gradebook": "Diário de notas",
  "Grades": "Notas",
  "Hard": "Difícil",
  "Health": "Saúde",
  "Hi! I'm your AI assistant.": "Olá! Sou seu assistente de IA.",
  "High": "Alto",
  "History": "História",
  "Hook/Intro": "Gancho/Introdução",
  "How do I teach fractions?": "Como ensinar frações?",
  "How to capture attention...": "Como captar a atenção...",
  "How to close the lesson...": "Como encerrar a aula...",
  "I can help you with lesson planning, teaching strategies, and questions about standards.": "Posso ajudar com planejamento de aulas, estratégias de ensino e dúvidas sobre padrões.",
  "Ideas for reading activities": "Ideias de atividades de leitura",
  "Instructions for students...": "Instruções para os alunos...",
  "Instructions for this question (optional)...": "Instruções para esta pergunta (opcional)...",
  "Instructions:": "Instruções:",
  "Integration with other subjects": "Integração com outras disciplinas",
  "Item": "Item",
  "Kindergarten": "Educação Infantil",
  "Language": "Idioma",
  "Learning Goal": "Objetivo de aprendizagem",
  "Learning Objective/s": "Objetivo(s) de aprendizagem",
  "Lesson Date Range": "Período da aula",
  "Lesson Plan": "Plano de aula",
  "Lesson Templates": "Modelos de aula",
  "Lesson Topic": "Tópico da aula",
  "Lessons": "Aulas",
  "Light": "Claro",
  "Light mode": "Modo claro",
  "Link copied": "Link copiado",
  "Link copied to clipboard": "Link copiado para a área de transferência",
  "Link copied!": "Link copiado!",
  "List of materials...": "Lista de materiais...",
  "Loading templates...": "Carregando modelos...",
  "Low": "Baixo",
  "Manage Grade Categories": "Gerenciar categorias de notas",
  "Manage your classes and students": "Gerencie suas turmas e alunos",
  "Manual Assignments": "Tarefas manuais",
  "Match": "Correspondência",
  "Match:": "Relacione:",
  "Matching": "Correspondência",
  "Materials Needed": "Materiais necessários",
  "Math": "Matemática",
  "Mathematics": "Matemática",
  "Medium": "Médio",
  "Multiple Choice": "Múltipla escolha",
  "Music": "Música",
  "My Prep Batches": "Minhas preparações",
  "My Templates": "Meus modelos",
  "Name (English)": "Nome (inglês)",
  "Name (Spanish)": "Nome (espanhol)",
  "Name is required": "O nome é obrigatório",
  "New Lesson": "Nova aula",
  "New Weekly Prep": "Nova preparação semanal",
  "New chat": "Novo chat",
  "No assignments": "Sem tarefas",
  "No assignments created": "Nenhuma tarefa criada",
  "No categories. Create one to get started.": "Sem categorias. Crie uma para começar.",
  "No classes today": "Sem aulas hoje",
  "No classes yet": "Ainda sem turmas",
  "No content to save": "Nenhum conteúdo para salvar",
  "No email generated": "Nenhum e-mail gerado",
  "No pending assignments": "Nenhuma tarefa pendente",
  "No prep batches yet": "Ainda sem preparações",
  "No questions found in the PDF": "Nenhuma pergunta encontrada no PDF",
  "No questions to print": "Nenhuma pergunta para imprimir",
  "No quiz generated": "Nenhum quiz gerado",
  "No risk alerts at this time": "Nenhum alerta de risco no momento",
  "No saved plans yet": "Ainda sem planos salvos",
  "No saved templates": "Nenhum modelo salvo",
  "No students": "Sem alunos",
  "No students in this class": "Sem alunos nesta turma",
  "No students yet": "Ainda sem alunos",
  "No suggestions to save": "Nenhuma sugestão para salvar",
  "Number of Questions": "Número de perguntas",
  "Number of questions": "Número de perguntas",
  "Open Portal": "Abrir portal",
  "Option": "Opção",
  "Optional: add specific details...": "Opcional: adicione detalhes específicos...",
  "Or adapt for your specific topic:": "Ou adapte para seu tópico específico:",
  "Or create a new prep batch above": "Ou crie uma nova preparação acima",
  "Or customize for new topic:": "Ou personalize para um novo tópico:",
  "Original topic:": "Tópico original:",
  "Other": "Outro",
  "Overdue": "Atrasado",
  "Parent Email": "E-mail aos pais",
  "Parent Portal": "Portal dos pais",
  "Period": "Período",
  "Physical Education": "Educação Física",
  "Plan Title": "Título do plano",
  "Plan Type": "Tipo de plano",
  "Plan created": "Plano criado",
  "Plan deleted": "Plano excluído",
  "Plan duplicated": "Plano duplicado",
  "Plan generated! Review and edit as needed.": "Plano gerado! Revise e edite conforme necessário.",
  "Plan saved!": "Plano salvo!",
  "Plan updated": "Plano atualizado",
  "Play to Learn": "Jogar para aprender",
  "Please add an objective or topic first to generate suggestions": "Adicione primeiro um objetivo ou tópico para gerar sugestões",
  "Please add an objective or topic first to generate the weekly plan": "Adicione primeiro um objetivo ou tópico para gerar o plano semanal",
  "Please allow pop-ups to print": "Permita pop-ups para imprimir",
  "Please enter a new topic": "Digite um novo tópico",
  "Please fill in all fields": "Preencha todos os campos",
  "Please fill in all required fields": "Preencha todos os campos obrigatórios",
  "Please respond in English.": "Please respond in Portuguese.",
  "Prep Agent": "Agente de preparação",
  "Prep agent started": "Agente de preparação iniciado",
  "Prep failed": "Falha na preparação",
  "Presentations": "Apresentações",
  "Pricing": "Preços",
  "Print": "Imprimir",
  "Print / PDF": "Imprimir / PDF",
  "Print / Save PDF": "Imprimir / Salvar PDF",
  "Published": "Publicado",
  "Question Types": "Tipos de perguntas",
  "Quick Actions": "Ações rápidas",
  "Quiz/Assessment": "Quiz/Avaliação",
  "Quiz/Test": "Quiz/Teste",
  "Ready for review": "Pronto para revisão",
  "Regenerate": "Regenerar",
  "Report Cards": "Boletins",
  "Save": "Salvar",
  "Save & Get Student Link": "Salvar e obter link do aluno",
  "Save Changes": "Salvar alterações",
  "Save Content": "Salvar conteúdo",
  "Save Template": "Salvar modelo",
  "Save as Template": "Salvar como modelo",
  "Save this plan to reuse with different topics": "Salve este plano para reutilizar com outros tópicos",
  "Saved": "Salvo",
  "Saved Lesson Plans": "Planos de aula salvos",
  "Saved Content": "Conteúdo salvo",
  "ESL Support": "Suporte ESL",
  "Rubric adapted for English learners (WIDA + PR standards)": "Rubrica adaptada para alunos de inglês (padrões WIDA + PR)",
  "Generate ESL-level material for English learners (WIDA + PR standards)": "Gera material em nível ESL para alunos de inglês (padrões WIDA + PR)",
  "Saved on": "Salvo em",
  "Schedule will appear in your Command Center": "O horário aparecerá no seu centro de comando",
  "Science": "Ciências",
  "Select Tool": "Selecionar ferramenta",
  "Select a category": "Selecione uma categoria",
  "Select a class": "Selecione uma turma",
  "Select a class to view its students": "Selecione uma turma para ver seus alunos",
  "Select a prep batch to view details": "Selecione uma preparação para ver os detalhes",
  "Select class": "Selecionar turma",
  "Select...": "Selecionar...",
  "Semester": "Semestre",
  "Send Email": "Enviar e-mail",
  "Send via Email": "Enviar por e-mail",
  "Sending...": "Enviando...",
  "Share this link with the student's parents. The portal is read-only.": "Compartilhe este link com os pais do aluno. O portal é somente leitura.",
  "Short Answer": "Resposta curta",
  "Skill...": "Habilidade...",
  "Slides": "Slides",
  "Social Studies": "Estudos Sociais",
  "Spanish": "Espanhol",
  "Specify other activity...": "Especifique outra atividade...",
  "Specify other material...": "Especifique outro material...",
  "Standards": "Padrões",
  "Standards Framework": "Estrutura de padrões",
  "Start": "Início",
  "Start Prep Agent": "Iniciar agente de preparação",
  "Starter": "Inicial",
  "Starter Templates": "Modelos iniciais",
  "Story title": "Título da história",
  "Student": "Aluno",
  "Student PDF": "PDF do aluno",
  "Student Progress": "Progresso dos alunos",
  "Student added": "Aluno adicionado",
  "Student deleted": "Aluno excluído",
  "Student updated": "Aluno atualizado",
  "Students at Risk": "Alunos em risco",
  "Sub Packet": "Pacote para substituto",
  "Subject": "Disciplina",
  "Subject *": "Disciplina *",
  "Suggest activities": "Sugerir atividades",
  "Suggestions applied to notes": "Sugestões aplicadas às notas",
  "Tags (comma separated)": "Tags (separadas por vírgula)",
  "Take": "Fazer",
  "Taxonomy Levels (Webb 2005)": "Níveis taxonômicos (Webb 2005)",
  "Teacher": "Professor",
  "Teacher Name": "Nome do professor",
  "Teacher name": "Nome do professor",
  "Technology": "Tecnologia",
  "Template deleted": "Modelo excluído",
  "Template name *": "Nome do modelo *",
  "Template saved!": "Modelo salvo!",
  "Templates": "Modelos",
  "This will delete the class and all its students.": "Isso excluirá a turma e todos os seus alunos.",
  "To": "Até",
  "To Grade": "Para corrigir",
  "Today's Schedule": "Horário de hoje",
  "Tools": "Ferramentas",
  "Topic": "Tópico",
  "Topic *": "Tópico *",
  "Topic Summary": "Resumo do tópico",
  "Topic:": "Tópico:",
  "Total Weight": "Peso total",
  "Tour": "Tour",
  "True": "Verdadeiro",
  "True/False": "Verdadeiro/Falso",
  "Type your question...": "Digite sua pergunta...",
  "Upcoming Lessons": "Próximas aulas",
  "Update Assignment": "Atualizar tarefa",
  "Upload File": "Enviar arquivo",
  "Upload a test or document": "Envie um teste ou documento",
  "Uploading...": "Enviando...",
  "Use proven templates or save your own successful plans": "Use modelos comprovados ou salve seus próprios planos de sucesso",
  "Use this template": "Usar este modelo",
  "View": "Ver",
  "View All": "Ver tudo",
  "View Assignments": "Ver tarefas",
  "View starter templates": "Ver modelos iniciais",
  "Week 1": "Semana 1",
  "Week 1 - From": "Semana 1 - De",
  "Week 1 - To": "Semana 1 - Até",
  "Week 2": "Semana 2",
  "Week 2 - From": "Semana 2 - De",
  "Week 2 - To": "Semana 2 - Até",
  "Week Starts": "Início da semana",
  "Week of": "Semana de",
  "Weekly Prep Agent": "Agente de preparação semanal",
  "Weekly prep is ready!": "A preparação semanal está pronta!",
  "Welcome": "Bem-vindo(a)",
  "What does CCSS.MATH.4.NF say?": "O que diz CCSS.MATH.4.NF?",
  "Will save:": "Será salvo:",
  "Working on:": "Trabalhando em:",
  "Worksheet": "Folha de exercícios",
  "Worksheets": "Folhas de exercícios",
  "Write the learning objectives...": "Escreva os objetivos de aprendizagem...",
  "You need an active subscription": "Você precisa de uma assinatura ativa",
  "You need an active subscription to use the AI assistant": "Você precisa de uma assinatura ativa para usar o assistente de IA",
  "Your Request": "Seu pedido",
  "Your digital classroom": "Sua sala de aula digital",
  "Your saved lesson plans for easy access": "Seus planos de aula salvos para fácil acesso",
  "assignments": "tarefas",
  "classes scheduled": "aulas agendadas",
  "days": "dias",
  "days of activities": "dias de atividades",
  "en-US": "pt-BR",
  "graded": "corrigidas",
  "of total": "do total",
  "points": "pontos",
  "questions": "perguntas",
  "ready": "pronto",
  "students": "alunos",
  "submissions": "envios",
  "submissions pending": "envios pendentes",
  "used": "usado",
  "📅 Calendar file downloaded. Open it to add to Google Calendar, Outlook, or Apple Calendar.": "📅 Arquivo de calendário baixado. Abra-o para adicionar ao Google Calendar, Outlook ou Apple Calendar.",
  "📅 Schedule (Optional)": "📅 Horário (opcional)",
  "📅 Weekly Plan (2 Weeks)": "📅 Plano semanal (2 semanas)",
  "📗 Week 2": "📗 Semana 2",
  "📘 Week 1": "📘 Semana 1",
  "🗣️ Conversational English": "🗣️ Inglês para conversação",
  "🗣️ Conversational English Plan Details": "🗣️ Detalhes do plano de inglês para conversação"
};
